import { StringColumn } from 'baseui/data-table';

export const COL_NAMES = {
	sname: 'serviceName'
};

export const columnConfigs = [
	StringColumn({
		title: 'Service Name',
		width: 300,
		mapDataToValue: (data: any) => data.label
	})
];

export default columnConfigs;
